import Dialog from "./Dialog";

import React from 'react'

const DeleteModal = ({handleDeleteModal,isShow}) => {
  return (
    <Dialog
        isModalOpen={isShow}
        onToggleDialog={(isDialogOpen) => {if(!isDialogOpen){handleDeleteModal(false)}}}
        mode="small-half"
        isCloseIconHidden={false}
        >
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
        <h3 className="title">Are you sure you want to proceed?</h3>
        {/* <h4>{caseId}</h4> */}
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
        <button className="btn btn-viewPdf1" style={{ width: '6rem', height: '3.5rem' }} onClick={() => handleDeleteModal(true)}>Yes</button>
        <button className="btn btn-viewPdf1" style={{ marginLeft: '1rem' }} onClick={() => handleDeleteModal(false)}>No</button>
        </div>
    </Dialog>
  )
}

export default DeleteModal

